/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Basic color scheme for components.
 */
export let BASIC_COLOR_SCHEME;

/**
 * Icon Placement.
 */
(function (BASIC_COLOR_SCHEME) {
  BASIC_COLOR_SCHEME["REGULAR"] = "";
  BASIC_COLOR_SCHEME["INVERSE"] = "inverse";
})(BASIC_COLOR_SCHEME || (BASIC_COLOR_SCHEME = {}));
export let ICON_PLACEMENT;

/**
 * Constructor type. Used for defining mix-ins.
 */
(function (ICON_PLACEMENT) {
  ICON_PLACEMENT["LEFT"] = "left";
  ICON_PLACEMENT["RIGHT"] = "right";
})(ICON_PLACEMENT || (ICON_PLACEMENT = {}));
//# sourceMappingURL=defs.js.map
